/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React from 'react';
import Footer from '../../Components/Footer';
import Product100Tri from '../../Components/Product100';
import ScrollToTop from '../../Components/scrollup';
import ProductNav from '../../Components/productNav';
export default function Product100() {
  const moincher=100;
  return (
    <div className='products100' id='produits'>
        <div className='product'>
        <ScrollToTop/>
        <div className='nav'>
          <ProductNav/>
        </div>
        <div className='productContain'>
           <h2 className="pathTitle" key={Math.floor(Math.random() * 1)}>
              tout à -100 dt
            </h2>
   
        <ScrollToTop/>

       
          <Product100Tri moincher={moincher} />
        </div>
      </div>
      <Footer/>
    </div>
  );
}
